import React from 'react';
import styled from 'styled-components';
import Layout from '../../components/Layout';
import Card from '../../components/Card';

const SectionTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #1A2440;
  margin-bottom: 15px;
`;

const BusinessModelIcon = styled.div`
  background-color: #e3f2fd;
  border-radius: 8px;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  
  svg {
    width: 32px;
    height: 32px;
    color: #2196F3;
  }
`;

const BusinessModelSection = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
`;

const BusinessModelContent = styled.div`
  flex: 1;
`;

const BulletList = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding-left: 20px;
  
  li {
    margin-bottom: 8px;
  }
`;

const CompetitiveTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  
  th, td {
    padding: 12px 15px;
    text-align: left;
    border-bottom: 1px solid #e9ecef;
  }
  
  th {
    background-color: #f8f9fa;
    font-weight: 600;
    color: #1A2440;
  }
  
  tr:hover {
    background-color: #f8f9fa;
  }
`;

const BenchmarksTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  
  th, td {
    padding: 12px 15px;
    text-align: center;
    border-bottom: 1px solid #e9ecef;
    
    &:first-child {
      text-align: left;
    }
  }
  
  th {
    background-color: #f8f9fa;
    font-weight: 600;
    color: #1A2440;
  }
  
  tr:hover {
    background-color: #f8f9fa;
  }
`;

const ValuationPage: React.FC = () => {
  return (
    <Layout 
      companyName="ABC Co."
      sector="B2B"
      location="Subscription Model"
    >
      <Card>
        <BusinessModelSection>
          <BusinessModelIcon>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
          </BusinessModelIcon>
          <BusinessModelContent>
            <SectionTitle>Business Model</SectionTitle>
            <BulletList>
              <li>Enterprise software</li>
              <li>Recurring subscription</li>
              <li>Recurring subscription</li>
              <li>Diversified customer base</li>
            </BulletList>
          </BusinessModelContent>
        </BusinessModelSection>
      </Card>
      
      <Card>
        <SectionTitle>Competitive Landscape</SectionTitle>
        <CompetitiveTable>
          <thead>
            <tr>
              <th>Competitor</th>
              <th>Description</th>
              <th>Market Position</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Acme Inc.</td>
              <td>Leading ERP software</td>
              <td>Significant market share</td>
            </tr>
            <tr>
              <td>Beta Technologies</td>
              <td>CRM solutions</td>
              <td>Rapidly growing</td>
            </tr>
            <tr>
              <td>Delta Solutions</td>
              <td>Smaller SaaS vendor</td>
              <td>Niche focus</td>
            </tr>
          </tbody>
        </CompetitiveTable>
      </Card>
      
      <Card>
        <SectionTitle>Deal Structuring Clues</SectionTitle>
        <ul>
          <li>$150 million purchase price at 10x EBITDA</li>
          <li>25% equity rollover by management</li>
          <li>Performance-based earnout tied to revenue growth</li>
          <li>Low CapEx requirements</li>
        </ul>
      </Card>
      
      <Card>
        <SectionTitle>Benchmarks & Comparables</SectionTitle>
        <BenchmarksTable>
          <thead>
            <tr>
              <th>Company</th>
              <th>Revenue Multiple</th>
              <th>EBITDA Multiple</th>
              <th>Revenue Growth</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>ABC Co.</td>
              <td>6.0x</td>
              <td>12.0x</td>
              <td>15%</td>
            </tr>
            <tr>
              <td>Public SaaS Comps <span style={{ fontSize: '12px', color: '#6c757d' }}>(Avg)</span></td>
              <td>8.0x</td>
              <td>16.0x</td>
              <td>20%</td>
            </tr>
            <tr>
              <td>Private SaaS Comps <span style={{ fontSize: '12px', color: '#6c757d' }}>(Avg)</span></td>
              <td>4.0x</td>
              <td>10.0x</td>
              <td>10%</td>
            </tr>
          </tbody>
        </BenchmarksTable>
      </Card>
    </Layout>
  );
};

export default ValuationPage;
